// app/src/lib/cashflow/prefs.js — per-user cashflow preferences.

import { db } from '../db.js';
import { requireUserId } from '../procurement/util.js';

/** @typedef {{ userId:string, gapThresholdCents:number|null, pushAlertsEnabled:0|1, currency:string, renewalAlertDays:number }} CashflowPrefs */

const DEFAULTS = Object.freeze({
  gapThresholdCents: null, // null means "use 2× weekly average"
  pushAlertsEnabled: 0,
  currency: 'USD',
  renewalAlertDays: 14,
});

export async function get() {
  const userId = await requireUserId();
  const row = await db.cashflowPrefs.get(userId);
  return { userId, ...DEFAULTS, ...(row || {}) };
}

export async function update(patch) {
  const userId = await requireUserId();
  const cur = await get();
  const next = { ...cur, ...patch, userId };
  // Validate fields. Anything else is silently dropped to avoid attribute injection.
  const sanitized = {
    userId,
    gapThresholdCents: next.gapThresholdCents == null ? null : Math.max(0, Math.round(Number(next.gapThresholdCents))),
    pushAlertsEnabled: next.pushAlertsEnabled ? 1 : 0,
    currency: typeof next.currency === 'string' && /^[A-Z]{3}$/.test(next.currency) ? next.currency : cur.currency,
    renewalAlertDays: Number.isFinite(Number(next.renewalAlertDays)) ? Math.max(1, Math.min(60, Math.round(Number(next.renewalAlertDays)))) : cur.renewalAlertDays,
  };
  await db.cashflowPrefs.put(sanitized);
  return sanitized;
}
